export default __webpack_public_path__ + "images/e431f1b10d76e1b5237e1007fe50939d.svg";